import { Stack, Grid } from '@mui/material'
import ProducersFocus from './elements/producersFocus/ProducersFocus'
import LabelsFocus from './elements/LabelsFocus'
import AlbumsFocus from './elements/albumsFocus/AlbumsFocus'
import EventsFocus from './elements/EventsFocus'
import { PlaylistsFocus } from './elements/PlaylistsFocus'
import InterpretorsFocus from './elements/interpretorsFocus/InterpretorsFocus'
import BestTrackFocus from './elements/tracksFocus/BestTrackFocus'
import TracksStylesCard from './elements/TracksStylesCard'
import CountryCard from './elements/CountryCard'
import StylesDialog from '../dialog/StylesDialog'
import SearchDialog from '../dialog/SearchDialog'
import { useGetDiscoverQuery } from '../../api/discoverApiSlice'
import { useSelector } from 'react-redux'
import { selectCurrentCountry, selectCurrentStyle } from '../../actions/discoverSlice'


export default function DiscoverBoard() {
    const selectedStyle = useSelector(selectCurrentStyle)
    const selectedCountry = useSelector(selectCurrentCountry)

    const {
        data: discoverData,
        isFetching
    } = useGetDiscoverQuery({style: selectedStyle, country: selectedCountry})

    return (
        <Grid container spacing={1} sx={{height: {xs:'150%', md:'95%', lg:'100%'}}}>
            <Grid size={{ lg:1, md: 3, xs: 12}} sx={{height: {xs:'auto', md:'100%', lg:'100%'}}}>
                <Stack sx={{borderRadius: '10px', overflow: 'hidden', width: '100%', height: '100%'}}>
                    <Stack justifyContent={'center'} spacing={1} direction={'row'} sx={{display: {xs: 'none', md: 'none', lg: 'flex'}, m: 1}}>
                        <SearchDialog />
                        <StylesDialog discoverData={isFetching ? null : discoverData}/>
                    </Stack>
                    <Stack spacing={1} sx={{overflow: 'hidden', overflowY: 'scroll'}}>
                        <CountryCard />
                        <TracksStylesCard discoverData={isFetching ? null : discoverData} />
                    </Stack>
                </Stack>
            </Grid>
            <Grid size={{ lg: 5, md: 4, xs: 12}} sx={{height: {xs:'80%', md:'100%', lg:'100%'}}}>
                <Stack spacing={1} sx={{height: '100%'}}>
                    <ProducersFocus discoverData={isFetching ? null : discoverData}/>
                    <LabelsFocus discoverData={isFetching ? null : discoverData}/>
                    <Stack direction={{xs:'column', md: 'row', lg: 'row'}} spacing={1} sx={{height: '50%'}}>
                        <AlbumsFocus discoverData={isFetching ? null : discoverData}/>
                        <EventsFocus />
                    </Stack>
                </Stack>
            </Grid>
            <Grid size={{ lg: 6, md: 5, xs: 12}} sx={{height: {xs:'100%', md:'100%', lg:'100%'}, pb:{xs:'15%', sm:'10%', md: 0, lg: 0}}}>
                <Stack direction={'column'} spacing={1} sx={{height: '100%'}}>
                    <Stack direction={{xs: 'column', md: 'row', lg: 'row'}} spacing={1} sx={{height: {xs:'60%', md:'45%', lg:'45%'}}}>
                        <InterpretorsFocus discoverData={isFetching ? null : discoverData}/>
                        <PlaylistsFocus />
                    </Stack>
                    <BestTrackFocus discoverData={isFetching ? null : discoverData}/>
                </Stack>
            </Grid>
        </Grid>
    );
}











